import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  startStudySessionAPI,
  updateProgressAPI,
  getMyProgressAPI,
  checkFlashcardProgressAPI
} from "../../services/flashcardProgress";

export let startStudySession = createAsyncThunk(
  "flashcardProgress/start",
  async ({ flashcardId, review = false }, thunkApi) => {
    try {
      let response = await startStudySessionAPI(flashcardId, review);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let updateProgress = createAsyncThunk(
  "flashcardProgress/update",
  async ({ progressId, cardId, masteryLevel }, thunkApi) => {
    try {
      let response = await updateProgressAPI(progressId, cardId, masteryLevel);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let getMyProgress = createAsyncThunk(
  "flashcardProgress/my",
  async (_, thunkApi) => {
    try {
      let response = await getMyProgressAPI();
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let checkFlashcardProgress = createAsyncThunk(
  "flashcardProgress/check",
  async (flashcardId, thunkApi) => {
    try {
      let response = await checkFlashcardProgressAPI(flashcardId);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

let initialState = {
  loading: false,
  progress: [],
  currentSession: null,
  flashcardProgress: null,
  error: null,
  errorMsg: "",
  successMsg: ""
};

let flashcardProgressSlice = createSlice({
  name: "flashcardProgress",
  initialState,
  reducers: {
    clearProgress: (state, action) => {
      state.loading = false;
      state.error = null;
      state.errorMsg = "";
      state.successMsg = "";
      state.currentSession = null;
    },
    setCurrentSession: (state, action) => {
      state.currentSession = action.payload;
    }
  },
  extraReducers: {
    [startStudySession.pending]: (state, action) => {
      state.loading = true;
    },
    [startStudySession.fulfilled]: (state, action) => {
      state.loading = false;
      state.currentSession = action.payload.progress;
    },
    [startStudySession.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.errorMsg = "Failed to start study session";
    },
    [updateProgress.pending]: (state, action) => {
      state.loading = true;
    },
    [updateProgress.fulfilled]: (state, action) => {
      state.loading = false;
      state.currentSession = action.payload.progress;
      state.successMsg = "Progress updated successfully";
    },
    [updateProgress.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.errorMsg = "Failed to update progress";
    },
    [getMyProgress.pending]: (state, action) => {
      state.loading = true;
    },
    [getMyProgress.fulfilled]: (state, action) => {
      state.loading = false;
      state.progress = action.payload.progress;
    },
    [getMyProgress.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [checkFlashcardProgress.pending]: (state, action) => {
      state.loading = true;
    },
    [checkFlashcardProgress.fulfilled]: (state, action) => {
      state.loading = false;
      state.flashcardProgress = action.payload;
    },
    [checkFlashcardProgress.rejected]: (state, action) => {
      state.loading = false;
      state.flashcardProgress = null;
      state.error = action.payload;
    }
  }
});

let flashcardProgressReducer = flashcardProgressSlice.reducer;
export let { clearProgress, setCurrentSession } = flashcardProgressSlice.actions;
export default flashcardProgressReducer;

